<script setup>
import { computed } from 'vue'
import { DxDataGrid } from 'devextreme-vue/data-grid'

import { formattedSectionRows, reportFormattedRowKindEnum } from '@/composables/report'

const props = defineProps({
  formatted: {
    type: Object,
    required: true,
  },
  height: {
    type: String,
    default: null,
  },
})

const ROW_CLASSES = Object.freeze({
  [reportFormattedRowKindEnum.GROUP]: 'report-row-group',
  [reportFormattedRowKindEnum.SUBTOTAL]: 'report-row-subtotal',
  [reportFormattedRowKindEnum.TOTAL]: 'report-row-total',
  [reportFormattedRowKindEnum.CURRENCY_TOTAL]: 'report-row-total',
})

const gridOptionsFor = section => ({
  dataSource: formattedSectionRows(section, props.formatted.total_label),
  keyExpr: 'id',
  columns: section.headers.map((header, index) => ({
    dataField: `c${index}`,
    caption: header.label,
    alignment: header.numeric ? 'right' : 'left',
    allowSorting: false,
    encodeHtml: true,
  })),
  showBorders: true,
  showColumnLines: true,
  columnAutoWidth: true,
  wordWrapEnabled: true,
  allowColumnResizing: true,
  columnResizingMode: 'widget',
  height: props.height,
  paging: { enabled: false },
  sorting: { mode: 'none' },
  hoverStateEnabled: true,
  onRowPrepared: (e) => {
    if (e.rowType === 'data' && ROW_CLASSES[e.data.kind]) e.rowElement.classList.add(ROW_CLASSES[e.data.kind])
  },
})
const sectionGridOptions = computed(() => props.formatted.sections.map(gridOptionsFor))
</script>

<template>
  <div class="column q-gutter-y-md">
    <div v-for="(section, index) in props.formatted.sections" :key="section.key">
      <div v-if="props.formatted.sections.length > 1" class="text-subtitle2 text-primary q-mb-xs">{{ section.title }}</div>
      <dx-data-grid v-bind="sectionGridOptions[index]" />
    </div>
  </div>
</template>

<style scoped lang="scss">
:deep(.report-row-group) td {
  font-weight: 600;
  color: $primary;
  background-color: color-mix(in srgb, var(--q-primary) 8%, transparent);
}

:deep(.report-row-subtotal) td {
  font-weight: 600;
  background-color: color-mix(in srgb, var(--q-primary) 4%, transparent);
}

:deep(.report-row-total) td {
  font-weight: 700;
  border-top: 2px solid $grey-5;
}
</style>
